export default "__VITE_ASSET__B5bBQ6gU__"